import { ModuleFE_AdvisorWizard } from './ModuleFE_AdvisorWizard.js';
export const ModulePackFE_AdvisorWizardDB = [ModuleFE_AdvisorWizard];
//# sourceMappingURL=module-pack.js.map